import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/ru";
import { AppThemeProvider } from "./theme-mode";
import "./styles/crm.css";
import { AuthProvider } from "./auth/AuthContext";
import { BranchProvider } from "./auth/BranchContext";
import { App } from "./App";
import "./i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Не найден элемент #root в index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <AppThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <BranchProvider>
                <App />
              </BranchProvider>
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </LocalizationProvider>
    </AppThemeProvider>
  </StrictMode>,
);
